// extracted by mini-css-extract-plugin
export default {"wrapper":"ReportItemView_wrapper__i46gh","prettyTable":"ReportItemView_prettyTable__Mewk7"};